import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Equalizer } from './ui/Equalizer';
export function SolutionSection() {
  return <section id="solutions" className="py-24 bg-background relative overflow-hidden" data-id="element-185">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-186">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-187">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-188">
            <div className="inline-block px-3 py-1 bg-neon-cyan/10 border border-neon-cyan/30 rounded-full text-neon-cyan text-xs font-bold tracking-widest uppercase mb-6" data-id="element-189">
              The Lutegames Solution
            </div>
            <h2 className="text-4xl md:text-6xl font-display font-bold text-white mb-6 leading-tight" data-id="element-190">
              PERFECT <br data-id="element-191" />
              <span className="text-neon-cyan" data-id="element-192">SYNCHRONIZATION</span>
            </h2>
            <p className="text-xl text-gray-400 mb-8 leading-relaxed" data-id="element-193">
              We've rebuilt the audio engine from the ground up. Our proprietary
              "Beat-Lock" technology ensures every pixel moves in perfect
              harmony with every sound wave.
            </p>

            <ul className="space-y-6 mb-10" data-id="element-194">
              {['Zero-latency audio-visual response', 'Adaptive difficulty based on rhythm accuracy', 'Curated tracks from underground artists', 'Haptic feedback integration'].map((item, i) => <li key={i} className="flex items-center gap-4" data-id="element-195">
                  <div className="w-2 h-2 bg-neon-magenta rounded-full animate-pulse" data-id="element-196" />
                  <span className="text-lg text-gray-200" data-id="element-197">{item}</span>
                </li>)}
            </ul>

            <Button variant="secondary" glow data-id="element-198">
              Experience the Sync
            </Button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-199">
            {/* Abstract representation of sync */}
            <div className="aspect-square bg-surface rounded-2xl border border-white/10 p-8 relative overflow-hidden shadow-2xl" data-id="element-200">
              <div className="absolute inset-0 bg-gradient-to-br from-neon-cyan/5 to-neon-purple/5" data-id="element-201" />

              {/* Central pulsing core */}
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" data-id="element-202">
                <div className="w-32 h-32 bg-black rounded-full border-4 border-neon-cyan flex items-center justify-center shadow-[0_0_50px_rgba(0,240,255,0.3)] z-10 relative" data-id="element-203">
                  <div className="w-24 h-24 bg-gray-900 rounded-full flex items-center justify-center" data-id="element-204">
                    <Equalizer count={5} height="h-10" color="bg-white" data-id="element-205" />
                  </div>
                </div>
                {/* Ripples */}
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-32 h-32 border border-neon-cyan/50 rounded-full animate-ping" style={{
                animationDuration: '2s'
              }} data-id="element-206" />
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-48 h-48 border border-neon-magenta/30 rounded-full animate-ping" style={{
                animationDuration: '2s',
                animationDelay: '0.5s'
              }} data-id="element-207" />
              </div>

              {/* Orbiting elements */}
              <div className="absolute inset-0 animate-spin-slow" data-id="element-208">
                <div className="absolute top-10 left-1/2 w-4 h-4 bg-neon-amber rounded-full blur-[2px]" data-id="element-209" />
                <div className="absolute bottom-20 right-1/4 w-3 h-3 bg-neon-purple rounded-full blur-[2px]" data-id="element-210" />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}